import { useRef, createRef } from "react";

const useRefArray = (length: number) => {
  const refs = useRef<any>([]);

  if (refs.current.length !== length) {
    // add or remove refs
    refs.current = Array(length)
      .fill(0)
      .map((_, i) => refs.current[i] || createRef());
  }

  return refs;
};

export default useRefArray;
